import { get } from '@/service/request';
const notice = 'api/notice';

/** 取得重要通知資訊 */
export function getNoticeInfo() {
    return get(`${notice}/noticeInfo`);
}

/** 取得停機公告資訊 */
export function getPauseInfo() {
    return get(`${notice}/pauseInfo`);
}

/** 取得各功能停機維護訊息並隱藏該功能 */
export function getPauseFunctionInfo() {
    return get(`${notice}/pauseFunctionInfo`);
}
